import {createContext, useEffect, useRef, useState} from "react";
import useMenu from "../hooks/use-menu.js";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";

const getGeoLayerChecked = () => {
    let geoLayerLocalStorage = localStorage.getItem("geoLayerChecked");

    if (geoLayerLocalStorage) {
        geoLayerLocalStorage = JSON.parse(geoLayerLocalStorage);
        if (!Array.isArray(geoLayerLocalStorage)) return [];

        return geoLayerLocalStorage;
    }

    return [];
}

export const GisContext = createContext(undefined);

const GisProvider = ({children, sentryGrid, setTempCardParams, tempCardActionRef, tempCardParams}) => {
    const map = useMap();
    const coreLib = useMapsLibrary("core");
    const markerLib = useMapsLibrary("marker");
    const mapLib = useMapsLibrary("maps");
    const geometryLib = useMapsLibrary("geometry");

    const {menu, changeMenu} = useMenu();
    const [geoLayerChecked, setGeoLayerChecked] = useState(getGeoLayerChecked());
    const [drawingMode, setDrawingMode] = useState(false);

    const [target, setTarget] = useState({});
    const [modal, setModal] = useState({
        event: [],
        attendances: [],
        show: false,
    });

    const circleRange = useRef(undefined)

    useEffect(() => {
        if (!mapLib) return;

        circleRange.current = new mapLib.Circle({
            strokeColor: "#000",
            strokeOpacity: 0.5,
            strokeWeight: 2,
            fillColor: "#000",
            fillOpacity: 0.35,
            zIndex: 999
        })
    }, [mapLib]);

    useEffect(() => localStorage.setItem('geoLayerChecked', JSON.stringify(geoLayerChecked)), [geoLayerChecked]);

    return (
        <GisContext.Provider value={{
            menu,
            changeMenu,
            target,
            setTarget,
            modal,
            setModal,
            geoLayerChecked,
            setGeoLayerChecked,
            drawingMode,
            setDrawingMode,
            map,
            coreLib,
            markerLib,
            mapLib,
            geometryLib,
            circleRange,
            sentryGrid,
            setTempCardParams,
            tempCardActionRef,
            tempCardParams
        }}>
            {children}
        </GisContext.Provider>
    );
}

export default GisProvider;